import { Component, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { GridOptions } from 'ag-grid';
import { Router } from '@angular/router';
import * as encoding from 'encoding-japanese';
import { BookStockService } from '../../../service/book-stock/book-stock.service';
import { OwnerService } from '../../../service/owner/owner.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { config } from '../../../util/config';
import { insertcomma } from '../../../util/util';
import { AgGridHelper } from '../../../util/AgGridHelper';
import { isSingleOwner } from 'app/menu/header/header.component';

@Component({
  selector: 'app-root',
  templateUrl: 'wa6060.component.html',
  styleUrls: ['wa6060.component.scss']
})
export class Wa6060Component implements AfterViewInit {
  private gridApi: any;
  public componentTitle = 'WA6060:帳簿在庫照会';
  public owners: any;
  public ownerId: number;
  public targetDt: string;
  public gridOptions: GridOptions;
  public showGrid = false;
  public rowData: any[];
  public config = config;
  public working = false;
  public containerHeight = 500;
  public cardHeight = 500;
  public gridHeight = 500;
  public production = environment.production;
  public backgroundColor: string;
  public sessionOwnerKey = 'wa6050-owner';
  private errorInfo = '';
  @ViewChild('gridView')
  private gridView: ElementRef;
  private gridHelper: AgGridHelper;
  private paginationGetRowCount = 0;
  private paginationGetTotalPages = 0;
  private paginationGetCurrentPage = 0;
  private paginationGoToFirstPage;
  private paginationGoToNextPage;
  private isShowLoginModal = false;
  public rowsPerPageModel = [{ value: 10, viewValue: '10' }, { value: 20, viewValue: '20' }, { value: 100, viewValue: '100' }, { value: 500, viewValue: '500' }];
  public rowsPerPage = config.rowsPerPageSize;
  private isEnableClearFilter = null;
  private selectedCount = 0;
  private searchopen: boolean = true;
  private isOwnerFixed = false;

  constructor(
    private router: Router,
    private bookStockService: BookStockService,
    private ownerService: OwnerService,
    private commonService: CommonService,
    private dialogsService: DialogsService
  ) {
    this.gridHelper = new AgGridHelper();
    this.gridOptions = <GridOptions>{
      rowSelection: 'multiple',
      floatingFilter: true,
      enableRangeSelection: true,
      pagination: true,
      localeText: environment.gridLocale,
      getContextMenuItems: this.getContextMenuItems,
      onColumnResized: this.saveColumnWidth,
      shohwLoadingOverlay: true,
      onColumnMoved: () => {
        this.saveColumnOrder();
      },
      onGridReady: params => {
        this.gridApi = params;
        const columns = [];
        for (const column of params.columnApi.getAllDisplayedColumns()) {
          const idx = localStorage.getItem(`wa6060_${column.getColId()}_idx`);
          if (idx !== null) {
            columns.push({ idx: parseInt(idx, 10), column: column });
          }
        }
        columns.sort((a, b) => {
          return a.idx - b.idx;
        });
        for (let i = columns.length - 1; i >= 0; i--) {
          const column = columns[i];
          params.columnApi.moveColumn(column.column, column.idx);
        }
        this.gridHelper.onGridReady();
        this.gridHelper.autoTogglePagination();
      },
      onFilterChanged: () => {
        this.errorInfo = '';
        this.isEnableClearFilter = this.gridOptions.api.isAnyFilterPresent();
        this.gridHelper.onGridFilterChanged();
      },
      onRowDataChanged: () => {
        this.errorInfo = '';
        this.gridHelper.onRowDataChanged();

        this.selectedCount = 0;
      },
      onSelectionChanged: () => {
        this.errorInfo = '';
        this.selectedCount = this.gridOptions.api.getSelectedRows().length;
      },
      onPaginationChanged: () => {
        this.paginationGetRowCount = this.gridOptions.api.paginationGetRowCount();
        this.paginationGetTotalPages = this.gridOptions.api.paginationGetTotalPages();
        this.paginationGetCurrentPage = this.gridOptions.api.paginationGetCurrentPage() + 1;
        this.gridHelper.renderScrollArrow();
        this.gridHelper.autoTogglePagination();
        this.gridHelper.renderGridCheckboxImage();
      },
      postProcessPopup: params => {
        this.errorInfo = '';
        this.gridHelper.fixedAgMenu();
      },
      overlayLoadingTemplate: this.gridHelper.TEMPLATE_GRID_LOADING,
      overlayNoRowsTemplate: this.gridHelper.TEMPLATE_GRID_NODATA
    };
    this.gridOptions.columnDefs = [
      {
        headerName: '商品コード',
        field: 'itemCd',
        sort: 'asc',
        width: this.getColumnWidth('itemCd', 120),
        unSortIcon: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '商品名',
        field: 'itemTx',
        width: this.getColumnWidth('itemTx', 350),
        unSortIcon: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '単位',
        field: 'pcsunitTx',
        width: this.getColumnWidth('pcsunitTx', 100),
        unSortIcon: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '入数',
        field: 'caseamountNr',
        width: this.getColumnWidth('caseamountNr', 100),
        valueFormatter: insertcomma,
        unSortIcon: true,
        cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '在庫数',
        field: 'stockNr',
        width: this.getColumnWidth('stockNr', 100),
        valueFormatter: insertcomma,
        unSortIcon: true,
        cellClass: ['tr', 'cellclass']
      }
    ];
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
    this.gridHeight = window.innerHeight - config.headerMargin - config.containerPlaceHolderMargin - config.containerButtonMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
    this.gridHelper.setGridOptions(this.gridOptions);
    console.log(this.rowData);
    this.rowData = [];
  }

  getColumnWidth(id: string, def: number): number {
    return parseInt(localStorage.getItem(`wa6060_${id}_width`), 10) || def;
  }

  saveColumnWidth(params) {
    if (params.finished === true && params.type === 'columnResized') {
      localStorage.setItem(`wa6060_${params.column.colId}_width`, params.column.actualWidth);
    }
  }

  saveColumnOrder() {
    let idx = 0;
    for (const column of this.gridApi.columnApi.getAllDisplayedColumns()) {
      if (column.colId !== '0') {
        localStorage.setItem(`wa6060_${column.colId}_idx`, `${idx}`);
      }
      idx++;
    }
  }

  getContextMenuItems(params) {
    const str_to_unicode_array = str => {
      const arr = [];
      for (let i = 0; i < str.length; i++) {
        arr.push(str.charCodeAt(i));
      }
      return arr;
    };

    const download = csvString => {
      const unicode_array = str_to_unicode_array(csvString);
      const sjis_code_array = encoding.convert(
        unicode_array,
        'SJIS', // to
        'UNICODE' // from
      );

      const uint8_array = new Uint8Array(sjis_code_array);
      const blob = new Blob([uint8_array], { type: 'text/csv' });
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, 'export.csv');
      } else {
        // Chrome
        const downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.download = 'export.csv';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }
    };

    const result = [
      'copy',
      'copyWithHeaders',
      'separator',
      {
        name: 'エクスポート',
        subMenu: [
          {
            name: 'すべてCSVエクスポート',
            action: () => {
              download(params.api.getDataAsCsv());
            }
          },
          'excelExport'
        ]
      }
    ];

    return result;
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
  }

  onResizeGrid(event) {
    this.gridHeight = event.target.innerHeight - config.headerMargin - config.containerPlaceHolderMargin - config.containerButtonMargin;
  }

  ngAfterViewInit() {
    this.gridHelper.el = this.gridView;
    setTimeout(() => {
      this.onView();
    }, 500);
    if (isSingleOwner) {
      this.isOwnerFixed = true;
    } else this.isOwnerFixed = false;
  }

  onView() {
    this.ownerService
      .get()
      .then(outputJson => {
        this.owners = outputJson.owners;

        if (sessionStorage.getItem('ownerResult') != null && JSON.parse(sessionStorage.getItem('ownerResult')).ownerId !== undefined) {
          this.ownerId = JSON.parse(sessionStorage.getItem('ownerResult')).ownerId;
        } else {
          this.ownerId = undefined;
        }
        this.gridHelper.isOwnerNotFound = this.ownerId == null && this.ownerId !== undefined;
      })
      .catch(error => {
        this.errorInfo = this.commonService.getErrorMessage(error);
      });

    if (sessionStorage.getItem(this.sessionOwnerKey)) {
      this.ownerId = Number(sessionStorage.getItem(this.sessionOwnerKey));
      this.gridHelper.isOwnerNotFound = false;
      this.onSubmit();
    }
    sessionStorage.removeItem(this.sessionOwnerKey);
    sessionStorage.removeItem('isShowOwnerSelect');
  }

  onSubmit() {
    //SW-2103　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    this.onFilterClear();
    this.gridOptions.api.showLoadingOverlay();
    this.errorInfo = '';
    this.bookStockService
      .get(this.ownerId == null ? undefined : this.ownerId, this.targetDt)
      .then(outputJson => {
        this.rowData = outputJson.bookstocks;
        this.showGrid = true;
        setTimeout(() => {
          this.gridOptions.api.hideOverlay();
          this.working = false;
        },300);
      })
      .catch(error => {
        this.gridOptions.api.hideOverlay();
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
        this.showGrid = false;
        this.working = false;
      });
  }

  onFilterClear() {
    this.errorInfo = '';

    this.gridOptions.api.setFilterModel(null);
  }

  //表示件数の変更
  paginatorRowChange() {
    this.gridOptions.api.paginationSetPageSize(this.rowsPerPage);
    localStorage.setItem('wa6020_rowsPerPage_idx', `${this.rowsPerPage}`);
  }

  onSearchClear() {
    this.errorInfo = '';
    this.ownerId = undefined;
    this.targetDt = undefined;
  }

  searchslide() {
    this.errorInfo = '';

    if (this.searchopen === false) {
      this.searchopen = true;
    } else {
      this.searchopen = false;
    }
  }

  clrErr() {
    this.errorInfo = '';
  }

  ngDoCheck() {
    if (isSingleOwner) {
      this.isOwnerFixed = true;
    } else this.isOwnerFixed = false;
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa6Stock/wa6060/wa6060.component.ts